import { useMemo } from 'react';

import SFilter from '@/features/StructuredFilter/class/SFilter';
import useInsightExplorerStore from '@/stores/InsightExplorerStore';
import { STRUCTURED_FILTER_OPERATOR } from '@/types/structuredFilterConst';
import { isEmptyString } from '@/utils/util';

import { InsightExplorerByType } from '../types/constants';
import type { InsightExplorerPayload } from '../types/types';

const useExplorerPaylaod = () => {
  const { filterQueryFormats, searchValue, dateState, selectedNode, view } =
    useInsightExplorerStore();

  const filterPayload = useMemo(() => {
    const sFilter = new SFilter();
    sFilter.addFilterQueryFormats(filterQueryFormats);
    if (!isEmptyString(searchValue)) {
      sFilter.setIncludeSnippetFilter({
        op: STRUCTURED_FILTER_OPERATOR.OR,
        values: [searchValue],
      });
    }

    sFilter.setDateFilter({
      start_date: dateState.dateRange[0].toJSON(),
      end_date: dateState.dateRange[1].toJSON(),
    });

    return sFilter.get() || {};
  }, [JSON.stringify(filterQueryFormats), dateState, searchValue]);

  const payload: InsightExplorerPayload = {
    filter: filterPayload,
    by: selectedNode?.node_type || InsightExplorerByType.TAXONOMY,
    target_id: [selectedNode?.id || ''],
    view: view,
    view_type: dateState.rangeUnit,
  };

  return {
    filterPayload,
    payload,
  };
};

export default useExplorerPaylaod;
